module.exports = __webpack_public_path__ + "img/prt0002.prt.b35c1199.jpg";